<template>
<div class="list_model-recommend">
    <div v-for="(item, index) in list" :key="index">
        <div class="item-card" @click="onTapDetail(item.id)">
            <div class="image">
                <img class="bg-img"
                     v-lazy="item.image||item.image_url||item.cover_image_url"/>
            </div>
            <div class="info" :class="{'higher': category === 'show_item'}">
                <div class="up">
                    <div class="name" :class="{'shop': category=='site_shop'}">
                        {{item.name}}
                    </div>
                    <div class="tag">
                        <div v-for="(tag, order) in item.labels" :key="order">
                            <div class="tagItem" v-if="index<3">
                                {{tag}}
                            </div>
                        </div>
                    </div>
                    <div class="date" v-if="category==='show_item'">
                        {{item.time||''}}
                    </div>
                    <div class="score">
                        <v-score v-if="item.rating" :rating="item.rating"></v-score>
                        <div class="comment" v-if="item.reviews">
                            {{item.reviews}}{{ $t('home.comment') }}
                        </div>
                    </div>
                </div>
                <!--价格 评分-->
                <div class="bottom">
                    <!--景点、演出、活动（有ticket——type）-->
                    <div class="price-info"
                            v-if="category=='site'||category=='show_item'||category==='site_activity'">
                        <div class="has-price" v-if="item.ticket_type === 'supported'">
                            <div class="price-text" v-if="item.best_price!==null">
                                <span class="gray" v-if="$i18n.locale === 'en'">From&nbsp;</span>
                                <span class="red">{{ $t('common.symbol') }}</span>
                                <span class="digital">{{item.best_price/100}}</span>
                                <span class="gray" v-if="$i18n.locale === 'zh'">起</span>
                            </div>
                        </div>
                        <div class="has-price" v-else-if="item.ticket_type==='unsupported'">
                            <div class="price-text" v-if="item.low_price!==null">
                                <span class="gray" v-if="$i18n.locale === 'en'">From&nbsp;</span>
                                <span class="red">{{ $t('common.symbol') }}</span>
                                <span class="digital">{{item.low_price/100}}</span>
                                <span class="gray" v-if="$i18n.locale === 'zh'">起</span>
                            </div>
                        </div>
                        <div class="no-price" v-else>
                            {{ $t('home.free') }}
                        </div>
                    </div>
                    <!--酒店（直接显示最低价）-->
                    <div class="price-info"
                            v-if="category=='hotel'">
                        <div class="has-price" v-if="item.best_price!==0">
                            <div class="price-text" v-if="item.best_price!==null">
                                <span class="gray" v-if="$i18n.locale === 'en'">From&nbsp;</span>
                                <span class="red">{{ $t('common.symbol') }}</span>
                                <!--酒店价格单位为元-->
                                <span class="digital">{{item.best_price}}</span>
                                <span class="gray" v-if="$i18n.locale === 'zh'">起</span>
                            </div>
                        </div>
                        <div class="no-price" v-else>
                            <!--免费-->
                        </div>
                    </div>
                    <!--美食-->
                    <div class="price-info" v-if="category=='merchant'">
                        <div class="has-price" v-if="item.best_price&&item.best_price!=0">
                            <div class="price-text">
                                <span class="red">{{ $t('common.symbol') }}</span>
                                <span class="digital">{{item.best_price/100}}</span>
                                <span class="gray">{{ $t('common.eachPerson') }}</span>
                            </div>
                        </div>
                        <div class="no-price" v-else-if="item.best_price===0">
                            {{ $t('home.free') }}
                        </div>
                        <div class="no-price null" v-else>no price</div>
                    </div>
                    <!--购物-->
                    <div class="price-info" v-if="category=='site_shop'"></div>
                    <!--优惠-->
                    <div class="time-info" v-if="category=='poi_promotion'">
                        {{item.time||''}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Score from '@/components/Score.vue'

export default {
    props: {
        category: {
            type: String,
            default: 'site'
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
        'v-score': Score
    },
    methods: {
        onTapDetail(id){
            let url = ''
            // TraveLog Merchant site merchant hotel show_item site_shop site_activity PoiPromotion
            // 景区 餐厅 活动 演出 需要添加fromTrip
            if (this.category === 'poi_promotion'||this.category === 'poi_promotions'||this.category === 'PoiPromotion') {//优惠
                url = '/promotionDetail'
            }
            if (this.category === 'Site' || this.category === 'site') {//景点
                url = '/siteDetail'
            }
            if (this.category === 'Hotel' || this.category === 'hotel') {//酒店
                url = '/hotelDetail'
            }
            if (this.category === 'Merchant' || this.category === 'merchant') {//美食
                url = '/merchantDetail'
            }
            if (this.category === 'Show' || this.category === 'show_item'|| this.category === 'ShowItem'||this.category === 'show_items') {//演出
                url = '/showDetail'
            }
            if (this.category === 'SiteShop' || this.category === 'site_shop') {//购物
                url = '/mallDetail'
            }
            if (this.category === 'SiteActivity' || this.category === 'site_activity') {//活动
                url = '/eventDetail'
            }

            url += `/${id}`

            if (this.$route.query.language === 'zh') url += '?language=zh'

            this.$router.push(url)
        }
    }
}
</script>

<style lang="scss" scoped>
//列表模式
  .list_model-recommend{
    .item-card {
      display: flex;
      width: 100%;
      color: #ffffff;
      padding: 12px;
      //margin-bottom:24rpx;
      border-bottom: 6px solid #f7f7f7;
      &:last-child{
        border-bottom:none;
      }
      .image{
        position: relative;
        width: 100px;
        height: 100px;
        //border-radius: 16rpx;
        //will-change: transform;
        overflow: hidden;
        .bg-img{
          width: 100%;
          height: 100%;
          will-change: transform;
          background-color: #d8d8d8;
        }
        .trip-mask{
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          //bottom: -4rpx;
          width: 100%;
          height: 100%;
          font-size: 14px;
          color: #ffffff;
          //opacity: 0.5;
          //padding-top: 10rpx;
          background-color: rgba(0,0,0,0.5);
        }
      }
      .info{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        //width: 63%;
        width: calc(100% - 100px);
        height: 100px;
        margin-left:10px;
        padding: 6px 0 4px 0;
        &.higher{
          padding: 0 0 2px 0;
        }
        //width: 100%;
        .up{
          .name{
            max-width: 210px;
            font-size: 14px;
            font-weight: bold;
            font-family: "Montserrat";
            color: #222125;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .tag{
            display: flex;
            align-items: center;
            padding-top: 4px;
            .tagItem{
              display: flex;
              align-items: center;
              padding: 0 3px;
              height: 14px;
              border-radius: 2px;
              font-size: 10px;
              color: #ed9107;
              margin-right: 5px;
              border: solid 1px #ed9107;
              //max-width: 120rpx;
              //white-space: nowrap;
              //overflow: hidden;
              //text-overflow: ellipsis;
            }
          }
          .date{
            font-size: 10px;
            color: #888888;
            margin-top:5px;
            max-width:100%;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }
          .score{
            display: flex;
            align-items: center;
            margin-top: 6px;
            //transform: translateY(4rpx);
            .score-logo{
              margin-right: 4px;
            }
            .comment{
              font-size: 10px;
              color: #666666;
              margin-left:11px;
              transform: translateY(1px);
            }
          }
        }
        .bottom{
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          //align-items: baseline;
          width: 100%;
          //height: 36rpx;
          //margin-top:13.6rpx;
          .price-info{
            .has-price{
              display: flex;
              align-items: baseline;
              .price-text{
                color: #60c2ed;
                line-height: 1;
                .red{
                  display:inline-block;
                  font-size: 14px;
                  margin-right:2px;
                  transform: translateY(1px);
                }
                .digital{
                  display: inline-block;
                  font-size: 14px;
                  //font-weight:bold;
                  transform: translateY(1px);
                }
                .gray{
                  font-size: 11px;
                  margin-left:2px;
                }
              }
            }
            .no-price{
              line-height: 1;
              font-size: 14px;
              color: #60c2ed;
              padding-top: 5px;
              text-align: left;
              &.null{
                color: #fff;
              }
              .price-text{
                color: #60c2ed;
                line-height: 1;
                .red{
                  display:inline-block;
                  font-size: 14px;
                  margin-right:2px;
                  transform: translateY(1px);
                }
                .digital{
                  display: inline-block;
                  font-size: 14px;
                  //font-weight:bold;
                  transform: translateY(1px);
                }
                .gray{
                  font-size: 11px;
                  margin-left: 2px;
                }
              }
              //transform: translateY(2rpx);
            }
          }
          .time-info{
            max-width: 100%;
            font-size: 12px;
            font-weight: bold;
            font-family: "Montserrat";
            color: #60c2ed;
            //padding-top:8rpx;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          //添加景点至行程按钮
          .trip-btn{
            position: absolute;
            right: 0;
            bottom: 0;
            .btn{
              display: flex;
              align-items: center;
              justify-content: center;
              width: 52px;
              height: 26px;
              border-radius: 4px;
              font-size: 14px;
              //font-weight: bold;
              &.add{
                color: #ffffff;
                background-color: #f8a909;
              }
              &.remove{
                color: #888888;
                border: solid 1px #888888;
              }

            }
          }
        }
      }
    }
  }
</style>